/**
 * @generated SignedSource<<812ca137085c6ec3078ca3f899b9fe80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CancelPackageModal_memberPackage$data = {
  readonly id: string;
  readonly package: {
    readonly benefitsSummary: ReadonlyArray<{
      readonly description: string;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PackageBenefitsSummary_package" | "usePackageDisplayName_package">;
  };
  readonly " $fragmentType": "CancelPackageModal_memberPackage";
};
export type CancelPackageModal_memberPackage$key = {
  readonly " $data"?: CancelPackageModal_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"CancelPackageModal_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CancelPackageModal_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "usePackageDisplayName_package"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PackageBenefitsSummary_package"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BenefitsSummaryLine",
          "kind": "LinkedField",
          "name": "benefitsSummary",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "b0c9f15d0e0e412c0644ea267ca409d8";

export default node;
